import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core'
import * as moment from 'moment'
import { ReportsGateway } from '../../../gatewasys/reports.gateway'
import { SearchModel } from '../../../models/enrollment-search-details'
import { Router } from '@angular/router'
import { jqxGridComponent } from 'jqwidgets-ng/jqxgrid'
import { MedicareIDSearch } from '../../../models/MedicareIDSearch'

import { PortalGlobals } from '../../../../portalglobals'
import { ExcelService } from '../../../excel.service'
import * as _ from 'lodash'
import { Title } from '@angular/platform-browser';

@Component({
    selector: 'NEJEMedicareIDSearch',
    templateUrl: 'medicareid-search.component.html'
})
export class NEJEMedicareIDSearchComponent implements OnInit, OnDestroy {
    public loading = false
    width: number = 1240
    FmoModel: SearchModel
    ListValueId: string
    MedicareID: string
    medicareSearch: MedicareIDSearch[] = []
    @ViewChild('gridReference', { static: true }) myGrid: jqxGridComponent
    baseTitle: string

    constructor(
        private _routers: Router,
        private _reportsGateway: ReportsGateway,
        public _global: PortalGlobals,
        private _excelService: ExcelService,
        private titleService: Title
    ) {}

    ngOnDestroy(): void {
        this.titleService.setTitle(this.baseTitle)
    }

    cellsRenderer = function (row, columnfield, value, id) {
        return '<div class="jqx-grid-cell-left-align"><a style="vertical-align: middle;">' + value + '</a></div>'
    }

    source: any = {
        dataFields: [
            { name: 'ApplicantFirstName', type: 'string' },
            { name: 'ApplicantLastName', type: 'string' },
            { name: 'SubscriberID', type: 'string' },
            { name: 'ApplicantHICN', type: 'string' },
            { name: 'Description', type: 'string' },
            { name: 'DateOfEnrollment', type: 'string' },
            { name: 'CoverageEffectiveDate', type: 'string' },
            { name: 'TierTranslation', type: 'string' },

            { name: 'ApplicantMiddleInitial', type: 'string' },
            { name: 'ConfirmationNumber', type: 'string' },
            { name: 'TierTranslation', type: 'string' },
            { name: 'SubscriberId', type: 'string' },
            { name: 'Name', type: 'string' },
            { name: 'EnrollmentRecId', type: 'number' },
            { name: 'SourceId', type: 'string' },
            { name: 'AgentUserName', type: 'string' },
            { name: 'CUID', type: 'string' },
            { name: 'PrimaryCarrier', type: 'string' },
            { name: 'PrimaryAccount', type: 'string' },
            { name: 'PrimaryGroup', type: 'string' },
            { name: 'GroupName', type: 'string' }
        ],
        dataType: 'json',
        localData: this.medicareSearch
    }

    dataAdapter: any = new jqx.dataAdapter(this.source)
    /*
    columns: any[] = [

        { text: 'Application Date', dataField: 'DateOfEnrollment', width: 100 },
        { text: 'Applicant First Name', dataField: 'ApplicantFirstName', width: 100 },
    { text: 'Applicant Last Name', dataField: 'ApplicantLastName', width: 180 },
    { text: 'GID', dataField: 'SubscriberID', width: 105 },
    { text: 'Status', dataField: 'description', width: 140 },
    { text: 'Medicare Number', dataField: 'ApplicantHICN', width: 155 },
    
    { text: 'Effective Date', dataField: 'CoverageEffectiveDate', width: 165 },
        { text: 'Plan', dataField: 'TierTranslation', width: 50 },
        { text: 'Email', dataField: 'Email', width: 245 },
    ]
    */
    columns: any[] = [
        {
            text: 'Application Date',
            dataField: 'DateOfEnrollment',
            width: 100,
            cellsformat: 'd',
            cellsrenderer: this.cellsRenderer
        },
        {
            text: 'Effective Date',
            dataField: 'CoverageEffectiveDate',
            width: 90,
            cellsformat: 'd'
        },
        { text: 'Agent ID', dataField: 'AgentUserName', width: 110 },
        { text: 'Agent Name', dataField: 'Name', width: 120 },
        { text: 'Applicant First Name', dataField: 'ApplicantFirstName', width: 100 },
        { text: 'Applicant Last Name', dataField: 'ApplicantLastName', width: 100 },
        { text: 'G ID Number', dataField: 'SubscriberID', width: 100 },
        { text: 'Medicare Number', dataField: 'ApplicantHICN', width: 100 },
        { text: 'Plan', dataField: 'TierTranslation', width: 120 },
        { text: 'CUID', dataField: 'CUID', width: 80 },
        { text: 'PrimaryCarrier', dataField: 'PrimaryCarrier', width: 80 },
        { text: 'PrimaryAccount', dataField: 'PrimaryAccount', width: 80 },
        { text: 'PrimaryGroup', dataField: 'PrimaryGroup', width: 100 },
        { text: 'GroupName ', dataField: 'GroupName', width: 100 },
        { text: 'Status', dataField: 'Description', width: 230 }
    ]

    ngOnInit() {
        // Set unique title
        this.baseTitle = this.titleService.getTitle();
        this.titleService.setTitle( this.baseTitle + ' - Medicare ID Search')

        this.FmoModel = {} as SearchModel
        let today = new Date()
        var year = 2018 //this._global.selectedPlanYear;
        var month = 1
        var day = 10
        this.FmoModel.StartDate = moment().date(day).month(month).year(year).subtract('years', 1).format('M/D/YYYY')
        // this.FmoModel.StartDate = moment('10 / 1 / 2018').subtract('years',1).toDate();
        this.FmoModel.EndDate = moment(today).format('M/D/YYYY')

        if (this._reportsGateway.searchModel != null) {
            this.FmoModel = this._reportsGateway.searchModel
            this.getMedicareSearchList(this.FmoModel)
        }
    }

    getMedicareSearchList(FmoModel) {
        this.loading = true
        this._reportsGateway.getMedicareSearchData(FmoModel.searchText).subscribe(
            (data) => {
                this.medicareSearch = data
                this.source.localdata = this.medicareSearch
                this.dataAdapter.dataBind()
                this.myGrid.updatebounddata()
                this.loading = false
                this.removeMenuItemRoles(); 
            },
            (error) => {
                this.source.localdata = null
                this.dataAdapter.dataBind()
                this.myGrid.updatebounddata()
                this.loading = false
                this.removeMenuItemRoles(); 
            }
        )
    }

    onBack() {
        const insCo = this._global.currentUser.insuranceCompanyShortName.toLowerCase()
        this._routers.navigateByUrl('/' + insCo + '/reports/neje-my-clients/counts')
    }

    searchByMedicare(): void {
        if (this.FmoModel.searchText != null && this.FmoModel.searchText != undefined) {
            this.getMedicareSearchList(this.FmoModel)
        }
    }

    onPrint() {
        let gridContent = this.myGrid.exportdata('html')
        let newWindow = window.open('', '', 'width=800, height=500'),
            document = newWindow?.document.open(),
            pageContent =
                '<!DOCTYPE html>\n' +
                '<html>\n' +
                '<head>\n' +
                '<meta charset="utf-8" />\n' +
                '<title>Medicare Id Details </title>\n' +
                '</head>\n' +
                '<body>\n' +
                gridContent +
                '\n</body>\n</html>'
        document?.write(pageContent)
        document?.close()
        newWindow?.print()
    }

    //onExport() {
    //    if (this.FmoModel.searchText != null && this.FmoModel.searchText != undefined) {

    //        this._reportsGateway.getMedicareSearchDataExport(this.FmoModel.searchText)
    //            .subscribe(data => {
    //                let array = _.clone(data)
    //                let strArray = JSON.stringify(array)
    //                let counts = JSON.parse(strArray)
    //                this._excelService.exportAsExcelFile(counts, 'My Clients Report')
    //            },
    //                (error) => {

    //                })

    //    }
    //}

    onExport() {
        this.loading = true
        this.openWindowWithPost('/Reports/MyClientsSummary.aspx?From=medicareid', this.FmoModel.searchText)
        this.loading = false
    }

    openWindowWithPost(url: string, medicareId: string): void {
        var form = document.createElement('form')
        form.target = '_blank'
        form.method = 'POST'
        form.action = url
        form.style.display = 'none'

        var input = document.createElement('input')
        input.type = 'hidden'
        input.name = 'medicareId'
        input.value = medicareId
        form.appendChild(input)

        input = document.createElement('input')
        input.type = 'hidden'
        input.name = 'orgId'
        input.value = this._global.currentUser.orgId
        form.appendChild(input)

        input = document.createElement('input')
        input.type = 'hidden'
        input.name = 'userProfileId'
        input.value = this._global.currentUser.userProfileId.toString()
        form.appendChild(input)

        input = document.createElement('input')
        input.type = 'hidden'
        input.name = 'InsuranceCompanyName'
        input.value = this._global.currentUser.insuranceCompanyName
        form.appendChild(input)

        document.body.appendChild(form)
        form.submit()
        document.body.removeChild(form)
    }

    Cellclick(event: any): void {
        if (event.args.datafield === 'DateOfEnrollment') {
            this.FmoModel.EnrollmentRecId = event.args.row.bounddata.EnrollmentRecId
            this.FmoModel.SourceId = event.args.row.bounddata.SourceId
            localStorage.setItem('medicateCriteria', JSON.stringify(this.FmoModel))
            const insCo = this._global.currentUser.insuranceCompanyShortName.toLowerCase()
            let source = 'medicareid'
            this._routers.navigateByUrl('/' + insCo + '/reports/neje-my-clients/enrollment-details/' + source)
        }
    }
    onKeyDown(event) {
        const ENTER_KEY = 13
        if (event.keyCode === ENTER_KEY) {
            this.searchByMedicare()
        }
    }
    private removeMenuItemRoles(): void {
        setTimeout(() => {
            const menuItems = document.querySelectorAll('ul.jqx-menu-ul li[role="menuitem"]');
            menuItems.forEach((item) => item.removeAttribute('role'));
        }, 0);  // setTimeout ensures DOM has finished rendering
    }
}
